'use client'

import InfiniteScroll from 'react-infinite-scroll-component'
import { useState, useEffect, useTransition } from 'react'
import { Branch } from '@/types/branch'
import { Spinner, Center } from '@/components/Chakra'
import { FeedListItem } from '@/types/feed'
import { fetchFeedsAction, Card } from '@/features/feeds/client'
import { EmptyState } from '@/components/EmptyState'

type Props = {
  branch: Branch
  initialItems: FeedListItem[]
  totalPages?: number
}

export const BranchFeeds = ({ branch, initialItems, totalPages }: Props) => {
  const [isPending, startTransition] = useTransition()
  const [extraLoadedItems, setExtraLoadedItems] = useState<FeedListItem[]>([])
  const [page, setPage] = useState(1)
  const feeds = initialItems.concat(extraLoadedItems)

  useEffect(() => {
    if (page === 1) return
    const loadMore = () => {
      startTransition(async () => {
        const res = await fetchFeedsAction({ branch_id: branch.id, page })
        if (res.ok) {
          const loadedItems = res.payload
          setExtraLoadedItems(feeds.concat(loadedItems))
        }
      })
    }
    loadMore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <InfiniteScroll
      dataLength={feeds.length}
      next={() => {
        if (!isPending) {
          setPage(page + 1)
        }
      }}
      hasMore={typeof totalPages === 'undefined' ? true : page < totalPages}
      loader={
        <Center height="200px">
          <Spinner />
        </Center>
      }
    >
      {feeds.length === 0 ? (
        <EmptyState mt={10} title="フィードの投稿はありません" description={''} />
      ) : (
        <>
          {feeds.map((feed, index) => (
            <Card feed={feed} isLinkable={true} shouldShowFull={false} key={index} />
          ))}
        </>
      )}
    </InfiniteScroll>
  )
}
